import type { Guide } from '../types';

/**
 * S-02.11-01 — „Zaloguj jako” (decyzja Bartka 02.11.2026; scenariusz e2e 43). Tylko administrator
 * i administrator spółki — nagrywarka przechodzi kroki kontem administratora pokazowego. Czynności tylko
 * otwierają okno z powodem, niczego nie zapisują: start przejęcia zapisuje sesję i wpis w dzienniku, więc
 * kartę przejęcia z paskiem opisuje tekst kroku, a pokazuje scenariusz e2e.
 */
const PLANNER_ACCOUNT = {
  description: 'konto planisty FTL — z listy użytkowników',
  listPath: '/users',
};

export const guide: Guide = {
  flagKey: 'impersonation',
  title: 'Zaloguj jako inny użytkownik',
  whatItDoes:
    'Administrator może zobaczyć aplikację oczami pracownika — gdy ten zgłasza problem albo potrzebuje pomocy — bez znajomości jego hasła i bez wylogowania się ze swojego konta. „Zaloguj jako” przy koncie otwiera nową kartę, w której pracujesz jako ten pracownik: z jego rolą, uprawnieniami i spółką. Na górze tej karty stoi pasek „Pracujesz jako … — zalogowano przez …” z przyciskiem „Zakończ”; sesja kończy się tym przyciskiem albo po godzinie. Każda zmiana zapisana w tej karcie trafia do dziennika działań z nazwiskiem osoby, która się zalogowała. Wniosku złożonego w tej karcie nie rozstrzygniesz potem na swoim koncie (i odwrotnie) — zrobi to inna osoba. Administrator spółki loguje się tylko jako pracownicy swojej spółki; kont administratorów przejąć nie można.',
  audience: ['administrator', 'administrator spółki'],
  presentationItems: ['S-02.11-01'],
  steps: [
    {
      route: '/users',
      target: 'impersonate-button-*',
      title: '„Zaloguj jako” na liście użytkowników',
      description:
        'Ikona stoi tylko przy kontach, które wolno przejąć: nie przy Twoim, nie przy kontach administratorów ani kontach maszynowych, a administrator spółki widzi ją tylko przy pracownikach swojej spółki.',
      action: 'W menu „Użytkownicy” znajdź konto pracownika i najedź na ikonę „Zaloguj jako”.',
      recorder: { account: 'admin' },
    },
    {
      route: '/users/:userId',
      record: PLANNER_ACCOUNT,
      target: 'impersonate-button',
      title: 'To samo na karcie konta',
      description:
        'Na karcie konta przycisk „Zaloguj jako” stoi obok powrotu do listy.',
      action: 'Otwórz konto planisty i kliknij „Zaloguj jako”.',
      recorder: { account: 'admin', demo: { kind: 'user', account: 'ftl' } },
    },
    {
      route: '/users/:userId',
      record: PLANNER_ACCOUNT,
      target: 'impersonate-dialog',
      title: 'Powód i nowa karta',
      description:
        'Okno pyta o powód — co najmniej 10 znaków, trafi do dziennika działań razem z godziną i adresem. „Zaloguj jako” otwiera nową kartę z paskiem „Pracujesz jako … — zalogowano przez …”. W tej karcie nie zmienisz kont, ról, haseł, poświadczeń ani ustawień konta pracownika. „Zakończ” w pasku kończy sesję i zamyka kartę; Twoja karta przez cały czas zostaje na Twoim koncie i — dopóki sesja trwa — pokazuje ostrzeżenie, że w innej karcie pracujesz jako ktoś inny.',
      action: 'Wpisz powód i kliknij „Zaloguj jako” — albo „Anuluj”.',
      recorder: {
        account: 'admin',
        demo: { kind: 'user', account: 'ftl' },
        actions: [{ kind: 'click', target: 'impersonate-button' }],
      },
    },
  ],
};
